<template>
    <div>
        <template v-for="(item, i) in receiveRentTypeList">
            <span
                v-if="finalViewonly && info.receiveRentType == item.id"
                style="padding-left: 7px"
            >
                {{ item.text }}
            </span>
            <Radio
                v-if="!finalViewonly"
                :value="active === i"
                class="rent-radio"
                @input="onRentTypeInput($event, i)"
            >
                {{ item.text }}
            </Radio>

            <template
                v-if="
                    (item.id == 1 && !finalViewonly) ||
                    (item.id == 1 &&
                        info.receiveRentType == '1' &&
                        finalViewonly)
                "
            >
                <input-number
                    v-model="info.receiveRentNum[i]"
                    :allowDecimal="false"
                    :allowNegative="false"
                    :min="0"
                    :max="31"
                    placeholder="天数"
                    class="rent-num"
                    @on-focus="onRentValueFocus($event, item.id, i)"
                    @input="onRentValueInput"
                />
                <span class="rent-text">天收租</span>
            </template>

            <template
                v-if="
                    (item.id == 2 && !finalViewonly) ||
                    (item.id == 2 &&
                        info.receiveRentType == '2' &&
                        finalViewonly)
                "
            >
                <input-number
                    v-model="info.receiveRentNum[i]"
                    :allowDecimal="false"
                    :allowNegative="false"
                    :min="1"
                    :max="31"
                    placeholder="1-31"
                    class="rent-num"
                    @on-focus="onRentValueFocus($event, item.id, i)"
                    @input="onRentValueInput"
                />
                <span class="rent-text">号收租</span>
            </template>
        </template>
    </div>
</template>
<script>
import { Field } from 'ivux'

// 收租日设置
export default {
    name: 'RentDay',

    mixins: [Field],

    // 复合表单域
    composed: true,

    props: {
        // 收租方式
        receiveRentType: {
            type: [Number, String],
            default: 1,
        },
        // 收租日期
        receiveRentValue: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            active: 0,

            info: {
                receiveRentType: 1,
                receiveRentNum: [],
            },

            dict: {
                receiveRentType: this.$dict.NULL,
            },

            receiveRentTypeList: [],
        }
    },

    computed: {},

    watch: {
        receiveRentType(val) {
            this.info.receiveRentType = val
            this.active = Math.max(
                0,
                this.receiveRentTypeList.findIndex((v) => v.id === val)
            )
        },
        receiveRentValue(val) {
            this.info.receiveRentNum[this.active] = val
        },
    },

    created() {
        this.$dict.get(['receive_rent_type']).then((group) => {
            Object.assign(this.dict, group)

            this.receiveRentTypeList = group.receiveRentType.toList()

            // 初始化
            var active = Math.max(
                0,
                this.receiveRentTypeList.findIndex(
                    (v) => v.id === this.receiveRentType
                )
            )
            // 初始值为可以为0
            var receiveRentValue = this.receiveRentValue
            // 初始值为0，变为7
            // var receiveRentValue =
            //     this.receiveRentValue === 0 ? 7 : this.receiveRentValue
            this.info.receiveRentType = this.receiveRentType
            this.receiveRentTypeList.forEach((v, i) => {
                this.info.receiveRentNum.push(
                    i === active ? receiveRentValue : null
                )
            })
        })
    },

    methods: {
        getCurrentValue() {
            var rentValue = this.info.receiveRentNum[this.active]

            // 天数必填
            if (rentValue === '' || rentValue === null) {
                return {}
            }

            return {
                receiveRentType: this.info.receiveRentType,
                receiveRentValue: rentValue,
            }
        },

        onRentTypeInput(val, i) {
            // this.info.receiveRentType = val//这里会导致组件bug
            this.info.receiveRentType = this.receiveRentTypeList[i].id
            this.active = i

            this.emitChange()
        },

        onRentValueFocus(e, type, i) {
            this.info.receiveRentType = type
            this.active = i
        },

        onRentValueInput(val) {
            this.emitChange()
        },

        emitChange() {
            this.$emit('on-change', this.getCurrentValue())
            this.dispatchFormChange()
        },
    },
}
</script>
<style lang="less" scoped>
.rent {
    &-num {
        width: 60px;
        margin-right: 10px;
    }

    &-text {
        margin-right: 40px;

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>
